module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkOrder"
  }, [_c('xk-waiter', {
    attrs: {
      "src": '../../../../assets/img/yonghu/touxiang.jpg',
      "name": _vm.DjOrderInfo ? _vm.DjOrderInfo.driverName : '',
      "headImg": _vm.DjOrderInfo ? _vm.DjOrderInfo.driverPhoto : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_c('h2', [_c('span', {
    staticClass: "max"
  }, [_vm._v(_vm._s(_vm.DjPayInfo ? _vm.DjPayInfo.payMoney.toFixed(1).split('.')[0] : '0'))]), _vm._v(" "), _c('span', [_vm._v("." + _vm._s(_vm.DjPayInfo && _vm.DjPayInfo.payMoney ? _vm.DjPayInfo.payMoney.toFixed(1).split('.')[1] : '0') + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  }), _vm._v("查看明细")])]), _vm._v(" "), _c('xk-star', {
    attrs: {
      "defScore": _vm.DjQueryReview ? _vm.DjQueryReview.score : 5,
      "state": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, _vm._l((_vm.DjQueryReview ? _vm.DjQueryReview.tabs : null), function(item, index) {
    return _c('xk-tag-item', {
      key: index,
      attrs: {
        "name": item,
        "AcState": false
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "reviewContent"
  }, [_vm._v("\n      " + _vm._s(_vm.DjQueryReview && _vm.DjQueryReview.reviewContent && _vm.DjQueryReview.reviewContent !== '' ? _vm.DjQueryReview.reviewContent : '暂无评价') + "\n    ")])], 1), _vm._v(" "), _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', _vm._l((_vm.payDataFn), function(itme) {
    return (itme.val !== 0) ? _c('li', {
      staticClass: "clear"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(itme.name))]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "sum"
    }, [_vm._v(_vm._s(itme.val))]), _c('span', {
      staticClass: "unit"
    }, [_vm._v("元")])]), _vm._v(" "), (itme.time) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(itme.time)), _c('span', {
      staticClass: "unit"
    }, [_vm._v("分钟")])]) : _vm._e()]) : _vm._e()
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6954c5f1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/daijia/checkOrder.vue
// module id = 542
// module chunks = 0